import { z } from 'zod'

/**
 * Safe numeric URL param — returns undefined for empty strings or non-numeric input
 * instead of failing validation with NaN.
 * Use in TanStack Router validateSearch schemas for optional numeric filters.
 */
export const urlNumber = z.preprocess((val) => {
  if (val === '' || val === undefined || val === null) return undefined
  const n = Number(val)
  return Number.isNaN(n) ? undefined : n
}, z.number().optional())

const isMissingDate = (value: unknown) =>
  value === '' || value === null || value === undefined

/**
 * A date the user must fill: a cleared date input (null / empty string) is rejected instead
 * of being coerced to the epoch by `z.coerce.date()`.
 */
export const requiredDate = (message = 'Veuillez renseigner une date valide') =>
  z.preprocess(
    (value) => (isMissingDate(value) ? undefined : value),
    z.coerce.date({ error: () => message })
  )

/** Same as `requiredDate`, but a cleared input is simply absent. */
export const optionalDate = (message = 'Veuillez renseigner une date valide') =>
  z.preprocess(
    (value) => (isMissingDate(value) ? undefined : value),
    z.coerce.date({ error: () => message }).optional()
  )
